import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RequestCardState {
  loading: boolean;
  requestCardOptions: any | null;
  requestCard: any | null;
  error: any | null;
}

const initialState: RequestCardState = {
  loading: false,
  requestCardOptions: null,
  requestCard: null,
  error: null,
};

const requestCardSlice = createSlice({
  name: 'requestcard',
  initialState,
  reducers: {
    // Fetch card lock status
    fetchRequestCardRequest(state, action) {
      state.loading = true;
      state.error = null;
      state.requestCardOptions = null;
      state.requestCard = null;
    },
    fetchRequestCardSuccess(state, action) {
      state.loading = false;
      state.requestCardOptions = action.payload;
      state.error = null;
    },
    fetchRequestCardFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateRequestCardRequest(state, action) {
      state.loading = true;
      state.error = null;
      state.requestCardOptions = null;
      state.requestCard = null;
    },
    updateRequestCardSuccess(state, action) {
      state.loading = false;
      state.requestCard = action.payload;
    },
    updateRequestCardFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetRequestCardSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  fetchRequestCardRequest,
  fetchRequestCardSuccess,
  fetchRequestCardFailure,
  updateRequestCardRequest,
  updateRequestCardSuccess,
  updateRequestCardFailure,
  resetRequestCardSlice,
} = requestCardSlice.actions;

export default requestCardSlice.reducer;
